import { render, staticRenderFns } from "./SendInvitationsConfirmDialog.vue?vue&type=template&id=7761e13a&"
import script from "./SendInvitationsConfirmDialog.vue?vue&type=script&lang=ts&"
export * from "./SendInvitationsConfirmDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports